import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-7ycy3o-0"
})(["display:flex;position:relative;flex-flow:column;justify-content:space-between;height:100%;padding:0 14px;background-color:transparent;text-align:center;overflow:visible;", " ", ""], getFont(-1), minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), getFont(0)));
export var Name = styled.div.withConfig({
  displayName: "partials__Name",
  componentId: "sc-7ycy3o-1"
})(["padding-top:24px;font-weight:600;", ";margin:auto 0;"], getFont(-1, 'compact'));
var commonStyles = css(["cursor:pointer;position:absolute;top:0;svg{width:18px;height:18px;}"]);
export var DeleteContainer = styled.div.withConfig({
  displayName: "partials__DeleteContainer",
  componentId: "sc-7ycy3o-2"
})(["", " right:0;&:hover{color:", " !important;}"], commonStyles, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.negative;
});
export var EditContainer = styled.div.withConfig({
  displayName: "partials__EditContainer",
  componentId: "sc-7ycy3o-3"
})(["", " left:0;display:flex;align-items:center;color:", ";span{", "}&:hover{color:", ";}"], commonStyles, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryL;
}, getFont(-1), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});